import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "allowClear", "value", "selectContainerClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { compose, renderComponent, branch } from 'recompose';
import PropTypes from 'prop-types';
import _isNil from 'lodash/isNil';

// components
import Select from '../../../../molecules/Select';
import Error from '../../components/error';
import FieldLabel from '../../components/fieldLabel';

// constants
import actionTypes from '../../constants/actionTypes';

// styles
import '../fieldRenderer.scss';
import styles from './Select.module.scss';
var Option = Select.Option;
export { Option };
var defaultFilterOption = function defaultFilterOption(input) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    props: {
      children: ''
    }
  };
  return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
}; // TO DO - CHECK WITH PRIYANK
var SelectBoxField = /*#__PURE__*/function (_PureComponent) {
  _inherits(SelectBoxField, _PureComponent);
  var _super = _createSuper(SelectBoxField);
  function SelectBoxField() {
    var _this;
    _classCallCheck(this, SelectBoxField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var _this$props = _this.props,
        id = _this$props.id,
        onAction = _this$props.onAction,
        additional = _this$props.additional;
      onAction({
        type: actionTypes.ON_FIELD_CHANGE,
        payload: {
          id: id,
          value: value,
          additional: additional
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSelectBox", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        props = _assertThisInitialize.props;
      var label = props.label,
        allowClear = props.allowClear,
        value = props.value,
        selectContainerClassName = props.selectContainerClassName,
        otherProps = _objectWithoutProperties(props, _excluded);
      return /*#__PURE__*/React.createElement("div", {
        className: "flex-auto-grow-shrink"
      }, /*#__PURE__*/React.createElement(Select, _extends({
        allowClear: allowClear,
        handleChange: _this.handleChange,
        className: otherProps.error ? 'error full-width' : 'full-width',
        containerClassName: "".concat(styles.container, " ").concat(selectContainerClassName)
      }, !_isNil(value) && {
        value: value
      }, otherProps)));
    });
    return _this;
  }
  _createClass(SelectBoxField, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: props.fieldClassName
      }, /*#__PURE__*/React.createElement(FieldLabel, props), this.renderSelectBox(), /*#__PURE__*/React.createElement(Error, {
        key: "warning",
        error: props.warning
      }));
    }
  }]);
  return SelectBoxField;
}(PureComponent);
SelectBoxField.propTypes = {
  id: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  allowClear: PropTypes.bool,
  hide: PropTypes.bool,
  filterOption: PropTypes.func,
  selectContainerClassName: PropTypes.string
};
SelectBoxField.defaultProps = {
  options: [],
  disabled: false,
  allowClear: false,
  hide: false,
  filterOption: defaultFilterOption,
  selectContainerClassName: ''
};
var nullComponent = function nullComponent() {
  return null;
};
var emptyComponent = branch(function (props) {
  return props.hide;
}, renderComponent(nullComponent));
export default compose(emptyComponent)(SelectBoxField);